import { RefObject } from 'react';
import { IGlobalHeaderUrls, IHeaderMenu, USER_TYPE } from '@belong/types';

export interface IGlobalHeaderDesktop {
  headerMenuContent: IHeaderMenu;
  currentUrl?: string;
  isLoggedIn: boolean;
  userType?: USER_TYPE;
  hideMyAccountLinks?: boolean;
  urls: IGlobalHeaderUrls;
  onExpanded?: (bool: boolean) => void;
  isNbnOrderCartReady?: boolean;
  navHeaderRef?: RefObject<HTMLDivElement | null>;
}

export const CONTAINERS = {
  CONTAINER_MAIN: 'content-main',
  CONTAINER_ACCOUNT: 'content-account',
  CONTAINER_SEARCH: 'content-search'
} as const;

export type THeaderDropdownWrapper = (typeof CONTAINERS)[keyof typeof CONTAINERS];
